import React from "react"
import types from "prop-types"
import { taskShape } from "utils/propTypeShapes"
import TaskGeneralResponse from "./TaskGeneralResponse"
import TaskSubform from "./TaskSubform"

const TaskResponse = ({ task, taskControls }) => {
  const { subform } = task
  const ResponseComponent = subform ? TaskSubform : TaskGeneralResponse

  return (
    <ResponseComponent task={task} taskControls={taskControls} />
  )
}

TaskResponse.propTypes = {
  task: taskShape.isRequired,
  taskControls: types.node.isRequired,
}

export default TaskResponse
